<template>
  <b-col sm="12">
    <b-btn @click="loadPrev()">Cargar equipos previos</b-btn>
    {{msj}}
  </b-col>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FormComponentPrevCatodico',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      msj: ''
    }
  },
  watch: {
    value: function (val) {
      this.$emit('valuechange', val)
    }
  },
  computed: {
    ...mapState({
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadPrev2 () {
      var obj = this
      this.msj = ''
      var filter = {
        selector: {},
        sort: [{ 'identification.date': 'desc' }],
        limit: 1
      }
      if (this.currmodel.identification && this.currmodel.identification.location) {
        if (this.currmodel.identification.location.flowline) {
          filter.selector['identification.location.flowline'] = { '$eq': this.currmodel.identification.location.flowline }
        }
        if (this.currmodel.identification.location.progressive) {
          filter.selector['identification.location.progressive'] = { '$eq': this.currmodel.identification.location.progressive }
        }
      }
      obj.get_db().then(function (db) {
        db.find(filter).then(function (res) {
          console.log(res.docs[0])
          if (res.docs[0].equipment) {
            obj.$emit('updatex', {
              action: 'set',
              target: 'equipment',
              id: null,
              object: res.docs[0].equipment
            })
          } else {
            obj.$set(this, 'msj', 'No hay registros previos')
          }
        })
      }).catch(function (err) {
        console.log(err)
      })
    },
    loadPrev () {
      var obj = this
      this.$dialog.confirm('¿Seguro que desea cargar los datos del registro anterior?', { okText: 'Cargar', cancelText: 'Cancelar' })
        .then(obj.loadPrev2).catch(function (err) {
          if (err) { console.log(err) }
        })
    }
  }
}
</script>
